import type { ReactElement } from "react";
import { controlCharsObject, notDisplayedKeywords } from "@quickpoint.me/shared";
import type { ElementProps } from "../functionalComponents/RenderPage";
import type { GridObject } from "./gridTypes";

export function calculatePortraitRowsAndColumns(
  elements: ReactElement<ElementProps>[],
): GridObject[] {
  let colIdx = 1;
  let rowIdx = 1;
  const gridArray: GridObject[] = [];

  elements.every((el) => {
    if (el.props.type === controlCharsObject["-->"].controlChar) return false;
    if (el.props.type === controlCharsObject["|"].controlChar) return true;

    if (notDisplayedKeywords.includes(el.props.type as string)) return true
    // if (el.props.isAutospaceElement) return true
    if (el.props.type === controlCharsObject["^^^"].controlChar) return true;

    if (el.props.type === controlCharsObject["---"].controlChar) {
      colIdx = 1;
      return true;
    }
    if (el.props.type === "background:") {
      if (gridArray[gridArray.length - 1]) gridArray[gridArray.length - 1].elArray.push(el);
      return true;
    }
    gridArray.push({
      col: colIdx,
      elArray: [el],
      lastColInRow: false,
      lastRowInGrid: false,
      maxCols: 0,
      isSplitCell: false,
      maxRows: 0,
      row: rowIdx,
    });

    rowIdx++;
    return true;
  });
  const maxCols = gridArray.reduce((acc, curr) => {
    if (curr.col > acc) return curr.col;
    return acc;
  }, 0);

  const maxRows = gridArray.reduce((acc, curr) => {
    if (curr.row > acc) return curr.row;
    return acc;
  }, 0);

  gridArray.forEach((el, idx) => {
    el.maxCols = maxCols;
    el.maxRows = maxRows;
    if (gridArray[idx + 1] && el.row !== gridArray[idx + 1].row) {
      el.lastColInRow = true;
    }
    if (!gridArray[idx + 1]) {
      el.lastColInRow = true;
      el.lastRowInGrid = true;
    }
  });

  return gridArray;
}
